import { GET_TALENTS, SET_RECRUITER } from "../constants";
import * as api from "../../services/api";

const setRecruiter = (id) => async (dispatch) => {
  try {
    const response = await api.getUserById(id);
    if (response.data.data) {
      dispatch({
        type: SET_RECRUITER,
        payload: response.data.data,
      });
    }
  } catch (error) {
    // console.log(error);
  }
};

const setTalents = (data) => (dispatch) => {
  dispatch({
    type: GET_TALENTS,
    payload: data,
  });
};

const clearTalent = () => (dispatch) => {
  dispatch({
    type: GET_TALENTS,
    payload: [],
  });
};

const actions = {
  setRecruiter,
  setTalents,
  clearTalent,
};

export default actions;
